import Cookies from 'js-cookie';

jQuery(function($) {

    /**
     * This function is called when a user clicks on the button in the list
     */
    $(document).on('click', '[data-enec-training-select-item]', function(e){

        var $el  = $(this).parents('[data-enec-training-list-item]');
        var data = $el.data('enec-training-list-item');

        if (!data || !data.items) {
            return;
        }

        var list_item = {
            'item_id': data.items[0].item_id,
            'index': data.items[0].index,
            'item_list_name': data.item_list_name,
            'item_list_id': data.item_list_id
        };

        enec_training_save_list_data(list_item);

        window.dataLayer = window.dataLayer || []; 
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
            window.dataLayer.push({ecommerce: null}); 

            // Measure clicking on more information in the list
            window.dataLayer.push({ 
                'event': 'ecommerce_select_item',
                'ecommerce': { 
                    'item_list_name': data.item_list_name,
                    'item_list_id': data.item_list_id,
                    'items': data.items
                },
            });
        });
    });


    /**
     * This function is called when a user loads a single digital product page
     */
    if ($('[data-enec-training-view]').length) {

        var $enec_el = $('[data-enec-training-view]');
        var post_id = $enec_el.data('enec-post-id');

        $.ajax({
            url      : themevars.ajaxurl,
            type     : 'POST',
            dataType : 'json',
            data     : {
                action : 'enec_training_view_item',
                post_id : post_id,
            }
        }).done(function(response) {

            if (true !== response.success || !response.data.items) {
                return;
            }

            // convert price string to float for datalayer
            response.data.items[0].price = parseFloat(response.data.items[0].price);
            response.data.total = parseFloat(response.data.total);

            if (response.data.items[0].discount) {
                response.data.items[0].discount = parseFloat(response.data.items[0].discount);
            }

            $enec_el.data('enec-items', response.data.items);
            $enec_el.data('enec-total', response.data.total);

            window.dataLayer = window.dataLayer || []; 
            window.didomiOnReady = window.didomiOnReady || [];
            window.didomiOnReady.push(function (Didomi) {
                window.dataLayer.push({ecommerce: null}); 

                // Measure viewing a product
                window.dataLayer.push({ 
                    'event': 'ecommerce_view_item',
                    'ecommerce': { 
                        'items': response.data.items
                    }
                });
            });
        });
    }


    /**
     * This function is called when a user clicks on the 'ja ik wil dit' button
     */
     $(document).on('click', '[data-enec-training-add-to-cart]', function(e){
        var $enec_el = $('[data-enec-training-view]');
        var items = $enec_el.data('enec-items');
        var total = $enec_el.data('enec-total');

        if (!total || !items) {
            return;
        }

        window.dataLayer = window.dataLayer || []; 
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
            window.dataLayer.push({ecommerce: null}); 

            // Measure clicking on a button
            window.dataLayer.push({ 
                'event': 'ecommerce_add_to_cart',
                'ecommerce': {
                    'items': items
                },
            });
        });
    });


    /**
     * Save list item data in cookie to use later in purchase event
     */
    function enec_training_save_list_data(list_item) {

        var cookie_name = 'ecOrdListData';

        var ecom_list_data = Cookies.get(cookie_name);
        var add_item = true;

        if (ecom_list_data) {
            ecom_list_data = JSON.parse(ecom_list_data);
        } else {
            ecom_list_data = [];
        }
        
        $.each(ecom_list_data, function(index, item) {
            // check if item is already in list to avoid adding duplicates
            if (item.item_id === list_item.item_id) {
                add_item = false;
            }
        });

        if (add_item) {
            ecom_list_data.push(list_item);
            Cookies.set(cookie_name, JSON.stringify(ecom_list_data));
        }
    }
});